// @flow

import * as React from 'react'
import moment from 'moment'
import { TableCell, TableRow, Chip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import AccountCircle from '@material-ui/icons/AccountCircle'
import KeyIcon from '@material-ui/icons/VpnKey'

import ContentItemDialog from './ContentItemDialog'
import useBooleanState from 'hooks/useBooleanState'

type Props = {
  integration: IntegrationCPHCMS,
  contentType: HCMSContentType,
  contentItem: HCMSContentItem,
}

const useStyles = makeStyles((theme) => ({
  submissionDateCell: {
    width: '250px',
  },
  clickableTableRow: {
    cursor: 'pointer',
  },
}))

function SubmissionHistoryResult({
  integration,
  contentItem,
  contentType,
}: Props) {
  const classes = useStyles()

  const [isViewingContent, viewContent, hideContent] = useBooleanState(false)

  const date = React.useMemo(
    () => moment(contentItem.created).format('MMM Do, YYYY h:mm a'),
    [contentItem.created]
  )

  return (
    <>
      <TableRow
        hover
        className={classes.clickableTableRow}
        onClick={viewContent}
        data-cypress="forms-submission-history-result"
      >
        <TableCell className={classes.submissionDateCell}>{date}</TableCell>
        <TableCell>
          <Chip
            data-cypress="submitted-by-user"
            variant="outlined"
            label={contentItem.createdBy}
            icon={
              contentItem.createdBy.startsWith('client:') ? (
                <KeyIcon />
              ) : (
                <AccountCircle />
              )
            }
          />
        </TableCell>
        <TableCell>{contentItem.status}</TableCell>
      </TableRow>
      <ContentItemDialog
        isOpen={isViewingContent}
        integration={integration}
        contentType={contentType}
        contentItem={contentItem}
        onClose={hideContent}
      />
    </>
  )
}

export default React.memo<Props>(SubmissionHistoryResult)
